import { Alert, Box, styled, Typography } from '@mui/material'
import ButtonBase from 'design-system/button'
import InputPassword from 'design-system/input/password'
import { StyledBox } from 'pages/Login'
import NavLinkBack from 'components/NavLinkBack'
import useRecovery from './useRecovery'
import { useLogo } from 'hooks/useLogo'
import { SaLogo } from 'components/SaLogo'

const StyledContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '200px',
  gap: theme.spacing(2),
  width: '100%'
}))

const RecoveryPage: React.FC = () => {
  const {
    onSubmit,
    state,
    actionState,
    errorsMap,
    password,
    confirmPwd,
    changeFieldValue,
    disableAction
  } = useRecovery()
  const logo = useLogo()

  const gettingActionStateMessage = () => {
    if (actionState == 'success') {
      return (
        <>
          <Alert severity='success' style={{ width: '100%', marginTop: 16 }}>
            Senha alterada com sucesso.
          </Alert>

          <NavLinkBack to='/' title='Ir para o login' />
        </>
      )
    }
    if (actionState === 'error') {
      return (
        <>
          <Alert severity='error' style={{ width: '100%', marginTop: 16 }}>
            Não foi possível redefinir a senha.
          </Alert>
          <NavLinkBack to='/' title='Ir para o login' />
        </>
      )
    }
    return (
      <>
        <InputPassword
          label='Nova senha'
          type='password'
          variant='outlined'
          onChange={e => changeFieldValue('password', e.target.value.trim())}
          value={password}
          error={errorsMap.has('password')}
          helperText={errorsMap.get('password')}
        />
        <InputPassword
          label='Confirmar senha'
          type='password'
          variant='outlined'
          onChange={e =>
            changeFieldValue('confirmPassword', e.target.value.trim())
          }
          value={confirmPwd}
          error={errorsMap.has('confirmPassword')}
          helperText={errorsMap.get('confirmPassword')}
        />
        <ButtonBase
          type='submit'
          sx={{ mt: 2, width: '100%' }}
          disabled={disableAction}
        >
          Alterar senha
        </ButtonBase>
      </>
    )
  }

  const showContent = gettingActionStateMessage()

  const renderState: { [k in IStateStdTypes]: React.ReactElement } = {
    error: (
      <>
        <Alert severity='error' style={{ width: '100%', marginTop: 16 }}>
          Este link é inválido ou já foi usado.
        </Alert>
        <NavLinkBack to='/' title='Ir para o login' />
      </>
    ),
    idle: (
      <Alert severity='info' style={{ width: '100%', marginTop: 16 }}>
        Verificando link...
      </Alert>
    ),
    loading: showContent,
    success: showContent
  }

  return (
    <form onSubmit={onSubmit}>
      <StyledBox>
        <img src={logo} alt='Sentinela' style={{ width: '300px' }} />

        <StyledContent>{renderState[state]}</StyledContent>

        <Box mt={4}>
          <Typography variant='body2' style={{ marginTop: 16 }}>
            Powered by
          </Typography>

          <SaLogo />
        </Box>
      </StyledBox>
    </form>
  )
}

export default RecoveryPage
